import React from 'react';
import icon1 from './icon-1.svg'
import icon2 from './icon-2.svg'
import icon3 from './icon-3.svg'
import icon4 from './icon-4.svg'
import icon5 from './icon-5.svg'
import icon6 from './icon-6.svg'
import './info-block-3.scss'
import {useTranslation} from "react-i18next";


function InfoBlock3() {
    const { t } = useTranslation()
    return <div className="info-block-3 container">
        <div className="info-block-3__top" data-aos="fade-right">
            <h3 className="info-block-3__title title">{t('info_block_3.title')}</h3>
            <span className="info-block-3__description">{t('info_block_3.description')}</span>
        </div>

        <div className="info-block-3__wrapper">

            <div className="info-block-3__item" data-aos="flip-down">
                <img src={icon1} alt=""/>
                <h5 className="info-block-3__item-title">{t('info_block_3.i1_title')}</h5>
                <span className="info-block-3__text">{t('info_block_3.i1_desc')}</span>
            </div>

            <div className="info-block-3__item" data-aos="flip-down">
                <img src={icon2} alt=""/>
                <h5 className="info-block-3__item-title">{t('info_block_3.i2_title')}</h5>
                <span className="info-block-3__text">{t('info_block_3.i2_desc')}</span>
            </div>

            <div className="info-block-3__item" data-aos="flip-down">
                <img src={icon3} alt=""/>
                <h5 className="info-block-3__item-title">{t('info_block_3.i3_title')}</h5>
                <span className="info-block-3__text">{t('info_block_3.i3_desc')}</span>
            </div>

            <div className="info-block-3__item" data-aos="flip-down">
                <img src={icon4} alt=""/>
                <h5 className="info-block-3__item-title">{t('info_block_3.i4_title')}</h5>
                <span className="info-block-3__text">{t('info_block_3.i4_desc')}</span>
            </div>

            <div className="info-block-3__item" data-aos="flip-down">
                <img src={icon5} alt=""/>
                <h5 className="info-block-3__item-title">{t('info_block_3.i5_title')}</h5>
                <span className="info-block-3__text">{t('info_block_3.i5_desc')}</span>
            </div>

            <div className="info-block-3__item" data-aos="flip-down">
                <img src={icon6} alt=""/>
                <h5 className="info-block-3__item-title">{t('info_block_3.i6_title')}</h5>
                <span className="info-block-3__text">{t('info_block_3.i6_desc')}</span>
            </div>

        </div>
    </div>;
}

export default InfoBlock3;